export function invariant(condition, message) {
    if (condition) {
        return;
    }
    throw new Error(message !== null && message !== void 0 ? message : 'Internal error');
}
